import { Card, CardContent, Paper, Typography } from '@mui/material'
import React from 'react'
import { LineChart } from '@mui/x-charts'
import { getCurrentMonthName } from '../../../../utils/dateFunctions'
import { HoursCustomItemTooltipContent } from '../../../admin/DashboardPage/utils'
import ChartTemplate from '../../../../components/Chart/ChartTemplate'

const HoursSpentCard = ({ data }) => {

    // console.log("HOURSS: ", data?.hoursData)

    const hoursChart = <LineChart
        xAxis={[{
            data: data?.hoursData?.map(item => item.day) || [],
            label: `${getCurrentMonthName()}`, max: 31,
        }]}
        series={[
            {
                data: data?.hoursData?.map(item => item?.totalHours) || [],
                showMark: false,
                // valueFormatter: (hours, { dataIndex }) => {
                //     const projects = hoursDashboardData[dataIndex]?.projects?.length ? hoursDashboardData[dataIndex].projects.join(", ") : "";
                //     const users = hoursDashboardData[dataIndex]?.users?.length ? hoursDashboardData[dataIndex].users.join(", ") : "";
                //     return `${hours} hours\n🔹 Projects: ${projects} 🔹 Users: ${users}`;
                // },
                // area: true,
            },

        ]}
        yAxis={[{ label: 'Hours' }]}
        margin={{ bottom: 60 }}
        slotProps={{
            legend: {
                labelStyle: {
                    fontSize: "12px"
                },
            },
        }}
        tooltip={{
            // trigger: "item", itemContent: (props) => HoursCustomItemTooltipContent(props, data?.hoursData, "hours")
        }}

    // slots={{
    //     axisContent: (props) => CustomItemTooltipContent(props, hoursDashboardData),
    //     itemContent: (props) => CustomItemTooltipContent(props, hoursDashboardData)
    // }}
    />
    return (
        <Paper elevation={2} sx={{ width: "500px", height: "328px" }}>
            <ChartTemplate chart={hoursChart} title={"Hours Spent"}
                width="inherit"
                height="inherit"
            // padding={1}
            />
        </Paper>

    )
}

export default HoursSpentCard